import api from '@pray/shared/utils/api';

import type { RecurringPushAudience, RecurringPushAudiencePayload } from './types';

// POST …/campaigns/recurring-push/:id/audiences — allowed on draft + active + stopped.
// The controller re-reads the parent so the returned audience DTO carries the
// resolved name + lead_count, not just the bare row.
export async function addRecurringPushAudience({
  artistId,
  recurringCampaignId,
  audience,
}: {
  artistId: string;
  recurringCampaignId: string;
  audience: RecurringPushAudiencePayload;
}): Promise<{ object: RecurringPushAudience }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push/${recurringCampaignId}/audiences`;
  const response = await api.executePostRequest<{ data: { object: RecurringPushAudience } }>(url, audience);
  return response.data.data;
}
